"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3_1 = require("d3");
/**
 * 图表事件管理对象
 * @since 2.0
 */
var Events = /** @class */ (function () {
    function Events(ctx, helpers) {
        /**
         * 是否为点击事件
         */
        this.isClick = false;
        this.ctx = ctx;
        this.helpers = helpers;
        this.init();
    }
    /**
     * 事件初始化
     */
    Events.prototype.init = function () {
        this.initGlobalEvents();
        this.initContainerEvents();
        this.initPlotEvents();
    };
    /**
     * 全局事件
     * @since 2.3
     */
    Events.prototype.initGlobalEvents = function () {
        var _this = this;
        d3_1.select(window).on("wheel", function () {
            var classPrefix = _this.ctx.theme.classPrefix;
            if (d3_1.event &&
                d3_1.event.relatedTarget &&
                d3_1.event.relatedTarget.className !== classPrefix + "-chart-tooltip") {
                _this.ctx.emit("container.mouse.left", d3_1.event.offsetX, d3_1.event.offsetY);
            }
        });
    };
    /**
     * HTML 根元素事件
     * @since 2.0
     */
    Events.prototype.initContainerEvents = function () {
        var _this = this;
        // 根元素鼠标事件
        d3_1.select(this.ctx.container)
            .on("mousemove touchmove", function () {
            // eslint-disable-next-line no-unused-expressions
            d3_1.event && d3_1.event.preventDefault();
            _this.ctx.emit("container.mouse.move", d3_1.event && d3_1.event.offsetX, d3_1.event && d3_1.event.offsetY);
        })
            .on("mouseleave touchend", function () {
            var classPrefix = _this.ctx.theme.classPrefix;
            if (d3_1.event &&
                d3_1.event.relatedTarget &&
                d3_1.event.relatedTarget.className !== classPrefix + "-chart-tooltip") {
                _this.ctx.emit("container.mouse.left", d3_1.event.offsetX, d3_1.event.offsetY);
            }
        })
            .on("mousedown", function () {
            _this.mousedownTimer = new Date().valueOf();
            _this.ctx.emit("container.mouse.down", d3_1.event && d3_1.event.offsetX, d3_1.event && d3_1.event.offsetY);
        })
            .on("mouseup", function () {
            _this.ctx.emit("container.mouse.up", d3_1.event && d3_1.event.offsetX, d3_1.event && d3_1.event.offsetY);
            var timer = new Date().valueOf();
            if (timer - _this.mousedownTimer < 200) {
                _this.isClick = true;
            }
        })
            .on("click", function () {
            // eslint-disable-next-line no-unused-expressions
            d3_1.event && d3_1.event.preventDefault();
            if (_this.isClick) {
                _this.ctx.emit("container.mouse.click", d3_1.event && d3_1.event.offsetX, d3_1.event && d3_1.event.offsetY);
                _this.isClick = false;
            }
        });
    };
    /**
     * 初始化鼠标事件
     *
     * @since 2.0
     */
    Events.prototype.initPlotEvents = function () {
        var _this = this;
        // 监听鼠标移动事件
        this.ctx.on("container.mouse.move", function (x, y) {
            // 如果 hover 到了非 svg 元素上需要忽略
            if (typeof d3_1.event.target.className === "string")
                return;
            var plotX = Number(_this.ctx.plotBackgound.attr("x"));
            var plotY = Number(_this.ctx.plotBackgound.attr("y"));
            var plotWidth = Number(_this.ctx.plotBackgound.attr("width"));
            var plotHeight = Number(_this.ctx.plotBackgound.attr("height"));
            var outBound = y > plotY + plotHeight ||
                y < plotY ||
                x > plotX + plotWidth ||
                x < plotX;
            if (outBound) {
                _this.ctx.emit("plot.mouse.left");
            }
            else {
                _this.ctx.emit("plot.mouse.move", x, y);
            }
        });
        // 监听鼠标离开事件
        this.ctx.on("container.mouse.left", function () {
            _this.ctx.emit("plot.mouse.left");
        });
        // 监听鼠标点击事件
        this.ctx.on("container.mouse.click", function (x, y) {
            var plotX = Number(_this.ctx.plotBackgound.attr("x"));
            var plotY = Number(_this.ctx.plotBackgound.attr("y"));
            var plotWidth = Number(_this.ctx.plotBackgound.attr("width"));
            var plotHeight = Number(_this.ctx.plotBackgound.attr("height"));
            var outBound = y > plotY + plotHeight || x > plotX + plotWidth;
            if (!outBound) {
                _this.ctx.emit("plot.mouse.click", x, y);
            }
        });
    };
    return Events;
}());
exports.Events = Events;
//# sourceMappingURL=event.js.map